<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">Vehicles</h4>
        </div>
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button @click="addFormInit" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
          <vs-button
            @click="viewData"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeData"
            icon="delete"
            :disabled="selectedId ? false : true"
          >Delete</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="showFilterForm = true"
            icon="filter_list"
          >Filter</vs-button>
          <vs-dropdown>
            <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
              <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
              <input type="file" ref="file" style="display: none" v-on:change="uploadExcel" />
              <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="data"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

      <!-- Form filter data -->
      <vs-prompt buttons-hidden title="Filter" :active.sync="showFilterForm">
        <div class="con-exemple-prompt">
          <vs-input
            v-model="filter.vehicle_code"
            class="mb-2 w-full wr_input"
            label="Vehicle Code"
          />
          <label class="vs-input--label">Transporter</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.transporter_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, transporter)"
          >
              <vs-select-item v-for="(item, index) in transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
          </vs-select>
          <label class="vs-input--label">Contract Type</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.contract_type_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, contract_type)"
          >
              <vs-select-item v-for="(item, index) in contract_type.data" :key="index" :value="item.id" :text="item.contract_type"/>
          </vs-select>
          <vs-input v-model="filter.driver" class="mb-2 w-full" label="Driver"/>
          <vs-input
            v-model="filter.phone"
            class="mb-2 w-full"
            label="Phone"
            @keypress="isNumber($event)"
            maxlength="13"
          />
          <label class="vs-input--label">Vehicle Type</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.vehicle_type_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, vehicle_type)"
          >
              <vs-select-item v-for="(item, index) in vehicle_type.data" :key="index" :value="item.id" :text="item.vehicle_type"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5" >
            <vs-button color="primary" @click="filterData">Search</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form view data -->
      <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
        <div class="con-exemple-prompt">
          <vs-input
            v-model="form.vehicle_code"
            class="mb-2 w-full wr_input"
            label="Vehicle Code *"
            :disabled="!editMode"
          />
          <label class="vs-input--label">Transporter *</label>
          <vs-select
              class="selectExample mb-2"
              v-model="form.transporter_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, transporter)"
              :disabled="!editMode"
          >
              <vs-select-item v-for="(item, index) in transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
          </vs-select>
          <label class="vs-input--label">Contract Type *</label>
          <vs-select
              class="selectExample mb-2"
              v-model="form.contract_type_id"
              width="100%"
              autocomplete
              :disabled="!editMode"
              @input-change="searchDropdown($event, contract_type)"
          >
              <vs-select-item v-for="(item, index) in contract_type.data" :key="index" :value="item.id" :text="item.contract_type"/>
          </vs-select>
          <vs-input v-model="form.driver" class="mb-2 w-full" label="Driver *" :disabled="!editMode"/>
          <vs-input
            v-model="form.phone"
            class="mb-2 w-full"
            label="Phone *"
            @keypress="isNumber($event)"
            maxlength="13"
            :disabled="!editMode"
          />
          <label class="vs-input--label">Vehicle Type *</label>
          <vs-select
              class="selectExample mb-2"
              v-model="form.vehicle_type_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, vehicle_type)"
              :disabled="!editMode"
          >
              <vs-select-item v-for="(item, index) in vehicle_type.data" :key="index" :value="item.id" :text="item.vehicle_type"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mr-2" @click="editMode = true">Edit</vs-button>
            <vs-button color="primary" @click="saveData" :disabled="!editMode">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form add data -->
      <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
        <div class="con-exemple-prompt">
          <vs-input
            v-model="form.vehicle_code"
            class="mb-2 w-full wr_input"
            label="Vehicle Code *"
          />
          <label class="vs-input--label">Transporter *</label>
          <vs-select
              class="selectExample mb-2"
              v-model="form.transporter_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, transporter)"
          >
              <vs-select-item v-for="(item, index) in transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
          </vs-select>
          <label class="vs-input--label">Contract Type *</label>
          <vs-select
              class="selectExample mb-2"
              v-model="form.contract_type_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, contract_type)"
          >
              <vs-select-item v-for="(item, index) in contract_type.data" :key="index" :value="item.id" :text="item.contract_type"/>
          </vs-select>
          <vs-input v-model="form.driver" class="mb-2 w-full" label="Driver *" />
          <vs-input
            v-model="form.phone"
            class="mb-2 w-full"
            label="Phone *"
            @keypress="isNumber($event)"
            maxlength="13"
          />
          <label class="vs-input--label">Vehicle Type *</label>
          <vs-select
              class="selectExample mb-2"
              v-model="form.vehicle_type_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, vehicle_type)"
          >
              <vs-select-item v-for="(item, index) in vehicle_type.data" :key="index" :value="item.id" :text="item.vehicle_type"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" @click="addData">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      gridOptions: {},
      gridApi: null,
      data: [],
      popupType: '',
      popupState: '',
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      selectedId: null,
      isLoading: false,
      editMode: false,
      filter: {
        vehicle_code: '',
        transporter_id: null,
        contract_type_id: null,
        vehicle_type_id: null,
        driver: '',
        phone: '',
      },
      form: {
        vehicle_code: '',
        transporter_id: null,
        contract_type_id: null,
        vehicle_type_id: null,
        driver: '',
        phone: '',
      },
      vehicleTypeOptions: [],
      contractTypeOptions: [],
      transporterOptions: [],

      // Show forms
      showFilterForm: false,
      showViewForm: false,
      showAddForm: false,

      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0,
      transporter: [],
      contract_type: [],
      vehicle_type: [],
      transporter: {
          data: [],
          loading: false,
          endpoint: 'master/transporters',
          objectKey: 'transporter_code'
      },
      contract_type: {
          data: [],
          loading: false,
          endpoint: 'master/contracttypes',
          objectKey: 'contract_type'
      },
      vehicle_type: {
          data: [],
          loading: false,
          endpoint: 'master/vehicletypes',
          objectKey: 'vehicle_type'
      },
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    saveData() {
      this.isLoading = true;
      this.$http
        .put("master/vehicle/" + this.selectedId + "/update", this.form)
        .then(() => {
          this.isLoading = false;
          this.form = {
            transporter_id: null,
            contract_type_id: null,
            vehicle_type_id: null,
            driver: "",
            phone: "",
            cap_volume: "",
            cap_weight: "",
            box_dimension: ""
          };
          this.editMode = false;
          this.showViewForm = false;
          this.selectedId = null;
          this.$vs.notify({
            color: "success",
            title: "Data Updated",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected data was successfully Updated"
          });
          this.fetchData();
        })
        .catch(error => this.handleError(error))
    },
    addData() {
      this.isLoading = true;
      this.$http
        .post("master/vehicle/store", this.form)
        .then(() => {
          this.isLoading = false;
          this.showAddForm = false;
          this.$vs.notify({
            color: "success",
            title: "Data Added",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected data was successfully Added"
          });
          this.fetchData();
        })
        .catch(error => this.handleError(error))
    },
    fetchTransporter(search, loading) {
      loading(true)
      const data = {
          transporter_code: search
      }
      this.$http.post('master/transporters', data)
      .then(res => {
        res.data.data.map(item => {
          const index = this.transporter.findIndex(a => a.value == item.id)
          if(index === -1) {
            this.transporter.push({
              value: item.id,
              label: item.transporter_code
            })
          }
        })
        loading(false)
      })
    },
    fetchContractType(search, loading) {
      loading(true)
      const data = {
          contract_type: search
      }
      this.$http.post('master/contracttypes', data)
      .then(res => {
        res.data.data.map(item => {
          const index = this.contract_type.findIndex(a => a.value == item.id)
          if(index === -1) {
            this.contract_type.push({
              value: item.id,
              label: item.contract_type
            })
          }
        })
        loading(false)
      })
    },
    fetchVehicleType(search, loading) {
      loading(true)
      const data = {
          vehicle_type: search
      }
      this.$http.post('master/vehicletypes', data)
      .then(res => {
        res.data.data.map(item => {
          const index = this.vehicle_type.findIndex(a => a.value == item.id)
          if(index === -1) {
            this.vehicle_type.push({
              value: item.id,
              label: item.vehicle_type
            })
          }
        })
        loading(false)
      })
    },
    removeData() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this data?",
        accept: () => {
          this.isLoading = true;
          this.$http
            .delete("master/vehicle/" + this.selectedId + "/destroy")
            .then(res => {
              this.$vs.notify({
                color: "success",
                title: "Data deleted",
                iconPack: "feather",
                icon: "icon-check",
                text: "The selected data was successfully deleted"
              });
              this.selectedId = null;
              this.fetchData();
            })
            .catch(error => this.handleError(error))
        }
      });
    },
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
    fetchData() {
      this.isLoading = true;
      Promise.all([
        this.$http.post("master/vehicle?page=" + this.currentPage, this.filter)
      ])
        .then(
          this.$http.spread(
            (vehicle) => {
              this.data = vehicle.data.data;
              this.totalPage = vehicle.data.last_page;
              this.currentPage = this.currentPage;
              this.dataTotal = vehicle.data.total;
              this.dataFrom = vehicle.data.from;
              this.dataTo = vehicle.data.to;
              this.isLoading = false;
            }
          )
        )
        .catch(() => {
          this.isLoading = false;
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Server Error",
            text: "Try again?",
            accept: () => {
              this.refreshData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
          return;
        });
      // .catch(() => {
      //   this.$vs.dialog({
      //     type: "confirm",
      //     color: "danger",
      //     title: "Error",
      //     text: "Try again?",
      //     accept: () => {
      //       this.refreshData();
      //     },
      //     acceptText: "Yes",
      //     cancelText: "No"
      //   });
      // })
      // .then(() => (this.isLoading = false));
    },
    addFormInit() {
      this.form = {
        vehicle_code: '',
        transporter_id: null,
        contract_type_id: null,
        vehicle_type_id: null,
        driver: '',
        phone: '',
      }
      this.showAddForm = true
    },
    viewData() {
      this.isLoading = true;
      this.$http
        .get("master/vehicle/" + this.selectedId)
        .then(res => {
          this.editMode = false
          if(this.transporter.data.findIndex(a => a.id == res.data.transporter_id) === -1) {
            this.transporter.data.push({
              id: res.data.transporter_id,
              transporter_code: res.data.transporter
            })
          }

          if(this.contract_type.data.findIndex(a => a.id == res.data.contract_type_id) === -1) {
            this.contract_type.data.push({
              id: res.data.contract_type_id,
              contract_type: res.data.contract_type
            })
          }

          if(this.vehicle_type.data.findIndex(a => a.id == res.data.vehicle_type_id) === -1) {
            this.vehicle_type.data.push({
              id: res.data.vehicle_type_id,
              vehicle_type: res.data.vehicle_type
            })
          }

          this.form = res.data;
          this.showViewForm = true;
        })
        .catch(error => this.handleError(error))
        .then(() => (this.isLoading = false));
    },
    filterData() {
      this.currentPage = 1;
      this.showFilterForm = false;
      this.fetchData();
    },
    getTemplate() {
      this.isLoading = true;
      this.$http
        .get("master/vehicle/report/gettemplate", {
          responseType: "blob"
        })
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "vehicle-upload-template.xlsx");
        });
    },
    uploadExcel(e) {
      let file = e.target.files[0];
      let form = new FormData();
      form.append("file", file);
      this.isLoading = true;
      this.$http
        .post("/master/vehicle/report/importexcel", form, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(resp => {
          this.isLoading = false;
          this.fetchData();
          this.$vs.notify({
            color: "success",
            title: "Upload Success",
            text: "Upload Data Vehicle Successfully"
          });
        })
        .catch(error => this.handleError(error));
    },
    exportExcel() {
      this.isLoading = true;
      this.$http
        .post("master/vehicle/report/exportexcel", this.filter, {
          responseType: "blob"
        })
        .then(response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });
          this.isLoading = false;
          saveAs(blob, "vehicle-list-export.xlsx");
        });
    },
    fetchDropdown() {
      this.isLoading = true
      return Promise.all([
        this.$http.post(
          "master/transporters",
        ),
        this.$http.post(
          "master/contracttypes",
        ),
        this.$http.post(
          "master/vehicletypes",
        ),
      ]).then(
        this.$http.spread((transporters, contracttypes, vehicletypes) => {
          transporters.data.data.map(transporter => {
            if(this.transporter.data.findIndex(a => a.id == transporter.id) === -1) {
              this.transporter.data.push(transporter)
            }
          })

          contracttypes.data.data.map(contract_type => {
            if(this.contract_type.data.findIndex(a => a.id == contract_type.id) === -1) {
              this.contract_type.data.push(contract_type)
            }
          })

          vehicletypes.data.data.map(vehicle_type => {
            if(this.vehicle_type.data.findIndex(a => a.id == vehicle_type.id) === -1) {
              this.vehicle_type.data.push(vehicle_type)
            }
          })
        })
      )
    },
  },
  mounted() {
    this.fetchDropdown().then(() => this.fetchData())
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Vehicle Code",
        field: "vehicle_code",
        width: 120,
      },
      {
        headerName: "Vehicle Type",
        field: "vehicle_type",
        width: 120,
      },
      {
        headerName: "Transporter ID",
        field: "transporter_code",
        width: 120
      },
      {
        headerName: "Contract Type",
        field: "contract_type",
        width: 120
      },
      {
        headerName: "Driver",
        field: "driver",
        width: 120
      }
    ];
    this.gridOptions.getRowHeight = function(params) {
        return 35;
    }
  }
};
</script>

<style lang="css">
.wr_input {
  border-radius: 12px;
}
</style>
